import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0309 from "../lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "22f32ae4-a284-4bfb-890f-fb4d98ded3eb",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0309),
    lesson: lesson0309,
  },
];

export default lessonLinks;
